// src/pages/AboutUs.jsx
import { Link } from 'react-router-dom';
import styles from './AboutUs.module.css';
import CoursesSection from '../components/home/CoursesSection'; 
import CompanyLogosSlider from '../components/includes/CompanyLogosSlider'; 
import AnimatedCounts from '../components/includes/AnimatedCounts';
// Make sure you have a banner image in this path for the hero section
import AboutBanner from '../assets/imgs/Bspark-Aboutus-Banner-1-01.jpg'; 
import TeamMeet from '../assets/imgs/About-inside.jpg'; 
import { useEffect } from 'react';
// Example of imports for one possible combination
import { FaChalkboardTeacher, FaLaptopCode, FaHandshake } from 'react-icons/fa';

const AboutUs = () => {
    useEffect(() => {
        document.title = "No.1 Training institute in Chennai || Bspark Software Technologies";
      }, []); // The empty dependency array ensures this runs only once
    
  return (
    <div className={styles.aboutUsPage}>
      {/* Hero Section */}
      <section className={styles.heroSection}
       style={{ backgroundImage: `url(${AboutBanner})` }}
       >
        <div className={styles.heroOverlay}>
          {/* <div className={styles.breadcrumb}>
            <Link to="/">Home</Link> &gt; <span>About Us</span>
          </div> */}
          <h1 className={styles.heroTitle}>Innovating the Future of Tech Education</h1>
          <p className={styles.heroDescription}>
            We are dedicated to bridging the skill gap and empowering professionals to thrive in the ever-evolving tech industry.
          </p>
        </div>
      </section>

      {/* Our Story / Mission Section */}
      <section className={styles.storySection}>
        <div className={styles.container}>
          <div className={styles.imageWrapper}>
            {/* You can replace this with a real image */}
            <img src ={TeamMeet} alt="Our team discussing a new project" className={styles.storyImage} />
          </div>
          <div className={styles.contentWrapper}>
            <h2 className={styles.sectionHeading}>Our Story</h2>
            <p>
              Founded by a team of industry veterans, our journey began with a simple goal: to provide high-quality, practical training that directly translates to career success. We saw a need for hands-on, job-oriented education that went beyond theory, and we built our platform to deliver just that.
            </p>
            <p>
              Today, we are a thriving community of learners and mentors, proud to have helped thousands of professionals achieve their career ambitions and become leaders in their fields.
            </p>
            <Link to="/corporate-training" className={styles.ctaButton}>Learn More About Our Training</Link>
          </div>
        </div>
      </section>
  
      {/* Mission and Vision Section */}
      <section className={styles.missionVisionSection}>
        <div className={styles.container}>
          <div className={`${styles.card} ${styles.missionCard}`}>
            <div className={styles.icon}>🎯</div>
            <h3 className={styles.cardTitle}>Our Mission</h3>
            <p>To provide cutting-edge, practical education that equips our students with the skills and confidence to excel in the global technology landscape.</p>
          </div>
          <div className={`${styles.card} ${styles.visionCard}`}>
            <div className={styles.icon}>🔭</div>
            <h3 className={styles.cardTitle}>Our Vision</h3>
            <p>To be the premier destination for technology education, recognized for our commitment to excellence, innovation, and student success.</p>
          </div>
        </div>
      </section>
      
      {/* Why Choose Us Section */}
      <section className={styles.whyUsSection}>
        <h2 className={styles.sectionHeading}>Why Choose Us?</h2>
        <div className={styles.container}>
          <div className={styles.reasonCard}>
             {/* <div className={styles.courseIconWrapper}>
            <FaChalkboardTeacher className={styles.courseMainIcon} />
        </div> */}
 <div className={styles.courseIconWrapper}><FaChalkboardTeacher className={styles.courseMainIcon}/></div>
            <h3 className={styles.cardTitle}>Expert Mentors</h3>
            <p>Learn from certified industry professionals with years of real-world experience.</p>
          </div>
          <div className={styles.reasonCard}>
  <div className={styles.courseIconWrapper}><FaLaptopCode className={styles.courseMainIcon}/></div>
            <h3 className={styles.cardTitle}>Hands-On Projects</h3>
            <p>Gain practical experience through immersive, project-based learning.</p>
          </div>
          <div className={styles.reasonCard}>
  <div className={styles.courseIconWrapper}><FaHandshake className={styles.courseMainIcon}/></div>
            <h3 className={styles.cardTitle}>Career Support</h3>
            <p>Benefit from our robust placement assistance and career guidance programs.</p>
          </div>
        </div>
      </section>

      {/* Reused components for consistency */}
      <section className={styles.featuredCoursesSection}>
        <CoursesSection />
      </section>
  <AnimatedCounts />
      <section className={styles.companyLogosSection}>
        {/* <h2 className={styles.sectionHeading}>Our Valued Partners</h2> */}
        <CompanyLogosSlider />
      </section>
    </div>
  );
};

export default AboutUs;